import { ApprovalDialog } from '@components/Forms';
import { useToast } from 'hooks';
import React from 'react';
import { IRowActionDialogProps } from 'types/common';

interface IItemDeleteDialogProps extends IRowActionDialogProps {
	questionLabelId: string;
	titleLabelId: string;
	toastLabelPrefix: string;
	deleteMutation: () => Promise<void>;
}

const ItemDeleteDialog: React.FC<IItemDeleteDialogProps> = ({
	onComplete,
	row,
	questionLabelId,
	titleLabelId,
	toastLabelPrefix,
	deleteMutation
}) => {
	const { invokeToastableAction } = useToast();

	const handleDelete = async () => {
		await invokeToastableAction(
			() => deleteMutation(),
			toastLabelPrefix,
			onComplete
		);
	};

	return (
		<ApprovalDialog
			onApprove={handleDelete}
			onCancel={onComplete}
			title={intl.tr(titleLabelId)}
			question={intl.tr(questionLabelId, {
				name: row?.row.name || ''
			})}
			approveText={intl.tr('button.delete')}
			cancelText={intl.tr('button.cancel')}
		/>
	);
};

export default ItemDeleteDialog;
